import Auth from './pages/auth/Auth';
import { Routes, Route } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/dashboard/Dashboard';
import AddBlog from './pages/blog/AddBlog';
import PublishedBlog from './pages/blog/PublishedBlog';
import UpdateBlog from './pages/blog/UpdateBlog';
import SheduledBlog from './pages/blog/SheduledBlog';
import DraftBlog from './pages/blog/DraftBlog';
import SheduleBlog from './pages/blog/SheduleBlog';
import DraftedBlog from './pages/blog/DraftedBlog';
import PostBlog from './pages/blog/PostBlog';
import EditBlogPost from './pages/blog/EditBlogPost';

function App() {
  return (
    <div className="">
      
       <Routes>
            <Route path="/" element={<Auth/>} />
            <Route path="/dashboard" element={<DashboardLayout/>} >
            <Route index element={<Dashboard/>} />
            {/* <Route path='/dashboard/blog/add' element={<AddBlog/>} /> */}
            <Route path='/dashboard/blog/published' element={<PublishedBlog/>}/>
            {/* <Route path='/dashboard/blog/edit/:slug' element={<UpdateBlog/>}/> */}
            <Route path='/dashboard/blog/sheduled' element={<SheduledBlog/>}/>
            {/* <Route path='/dashboard/blog/draft' element={<DraftBlog/>}/> */}
            <Route path='/dashboard/blog/drafted' element={<DraftedBlog/>}/>
            <Route path='/dashboard/blog/post' element={<PostBlog/>}/>
            <Route path='/dashboard/blog/update/:slug' element={<EditBlogPost/>}/>
            </Route>
         </Routes>




    </div>
  );
}

export default App;
